export const themeAttributeMap = {
  engineering: {
    dotGraphAttrs: [
      { name: "bgcolor", value: "dodgerblue" },
      { name: "color", value: "white" },
      { name: "fontname", value: "courier" },
      { name: "fontcolor", value: "white" }
    ],
    dotNodeAttrs: [
      { name: "color", value: "white" },
      { name: "fontname", value: "courier" },
      { name: "fontcolor", value: "white" }
    ],
    dotEdgeAttrs: [
      { name: "color", value: "white" },
      { name: "fontname", value: "courier" },
      { name: "fontcolor", value: "white" }
    ]
  },
  reverse: {
    dotGraphAttrs: [
      { name: "bgcolor", value: "black" },
      { name: "color", value: "white" },
      { name: "fontcolor", value: "white" }
    ],
    dotNodeAttrs: [
      { name: "color", value: "white" },
      { name: "fontcolor", value: "white" }
    ],
    dotEdgeAttrs: [
      { name: "color", value: "white" },
      { name: "fontcolor", value: "white" }
    ]
  },
  contrast: {
    dotGraphAttrs: [
      { name: "bgcolor", value: "black" },
      { name: "color", value: "yellow" },
      { name: "fontcolor", value: "yellow" }
    ],
    dotNodeAttrs: [
      { name: "color", value: "yellow" },
      { name: "fontcolor", value: "yellow" }
    ],
    dotEdgeAttrs: [
      { name: "color", value: "yellow" },
      { name: "fontcolor", value: "yellow" }
    ]
  },
  policetape: {
    dotGraphAttrs: [{ name: "bgcolor", value: "yellow" }],
    dotNodeAttrs: [],
    dotEdgeAttrs: []
  },
  transparent: {
    dotGraphAttrs: [{ name: "bgcolor", value: "transparent" }],
    dotNodeAttrs: [],
    dotEdgeAttrs: []
  },
  zany: {
    dotGraphAttrs: [
      { name: "bgcolor", value: "deeppink" },
      { name: "color", value: "green" },
      { name: "fontname", value: '"Comic Sans MS"' },
      { name: "fontcolor", value: "green" },
      { name: "nslimit", value: "0" },
      { name: "nslimit1", value: "1" }
    ],
    dotNodeAttrs: [
      { name: "color", value: "green" },
      { name: "fontname", value: '"Comic Sans MS"' },
      { name: "fontcolor", value: "green" }
    ],
    dotEdgeAttrs: [
      { name: "color", value: "green" },
      { name: "fontname", value: '"Comic Sans MS"' },
      { name: "fontcolor", value: "green" }
    ]
  }
};
